"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.funcOperation = void 0;
var engine_types_1 = require("@verified/c11-engine.types");
var observeOperation_1 = require("./observeOperation");
var valueOperation_1 = require("./valueOperation");
var funcOperation = function (db, structure, op) {
    var getParams = function (params) {
        var result = params.map(function (x) {
            if (x.type === engine_types_1.OperationTypes.OBSERVE) {
                var path = (0, observeOperation_1.observeOperation)(structure, x);
                if (path) {
                    return db.get(path);
                }
            }
            else if (x.type === engine_types_1.OperationTypes.VALUE) {
                return (0, valueOperation_1.valueOperation)(structure, x);
            }
            else {
                // operation not supported
            }
        });
        return result;
    };
    var params = getParams(op.value.params);
    // TODO: Maybe add a try catch here
    var value = op.value.fn.apply(null, params);
    return value;
};
exports.funcOperation = funcOperation;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZnVuY09wZXJhdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ncmFwaC9mdW5jT3BlcmF0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGtEQUsyQjtBQUMzQix1REFBc0Q7QUFDdEQsbURBQWtEO0FBRTNDLElBQU0sYUFBYSxHQUFHLFVBQzNCLEVBQXFCLEVBQ3JCLFNBQXlCLEVBQ3pCLEVBQWlCO0lBRWpCLElBQU0sU0FBUyxHQUFHLFVBQUMsTUFBVztRQUM1QixJQUFNLE1BQU0sR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFDLFVBQUMsQ0FBTTtZQUMvQixJQUFJLENBQUMsQ0FBQyxJQUFJLEtBQUssNkJBQWMsQ0FBQyxPQUFPLEVBQUU7Z0JBQ3JDLElBQU0sSUFBSSxHQUFHLElBQUEsbUNBQWdCLEVBQUMsU0FBUyxFQUFFLENBQUMsQ0FBQyxDQUFDO2dCQUM1QyxJQUFJLElBQUksRUFBRTtvQkFDUixPQUFPLEVBQUUsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLENBQUM7aUJBQ3JCO2FBQ0Y7aUJBQU0sSUFBSSxDQUFDLENBQUMsSUFBSSxLQUFLLDZCQUFjLENBQUMsS0FBSyxFQUFFO2dCQUMxQyxPQUFPLElBQUEsK0JBQWMsRUFBQyxTQUFTLEVBQUUsQ0FBQyxDQUFDLENBQUM7YUFDckM7aUJBQU07Z0JBQ0wsMEJBQTBCO2FBQzNCO1FBQ0gsQ0FBQyxDQUFDLENBQUM7UUFDSCxPQUFPLE1BQU0sQ0FBQztJQUNoQixDQUFDLENBQUM7SUFDRixJQUFNLE1BQU0sR0FBRyxTQUFTLENBQUMsRUFBRSxDQUFDLEtBQUssQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUUxQyxtQ0FBbUM7SUFDbkMsSUFBTSxLQUFLLEdBQUcsRUFBRSxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsS0FBSyxDQUFDLElBQUksRUFBRSxNQUFNLENBQUMsQ0FBQztJQUM5QyxPQUFPLEtBQUssQ0FBQztBQUNmLENBQUMsQ0FBQztBQXpCVyxRQUFBLGFBQWEsaUJBeUJ4QiJ9